/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app.index'
import { Route as AppThemeRouteImport } from './routes/_app.theme'
import { Route as AppTaxonomiesRouteImport } from './routes/_app.taxonomies'
import { Route as AppSettingsRouteImport } from './routes/_app.settings'
import { Route as AppRedirectsRouteImport } from './routes/_app.redirects'
import { Route as AppProfileRouteImport } from './routes/_app.profile'
import { Route as AppPatternsRouteImport } from './routes/_app.patterns'
import { Route as AppPageTemplatesRouteImport } from './routes/_app.page-templates'
import { Route as AppNewsletterRouteImport } from './routes/_app.newsletter'
import { Route as AppMessagesRouteImport } from './routes/_app.messages'
import { Route as AppIntegrationsRouteImport } from './routes/_app.integrations'
import { Route as AppChatbotRouteImport } from './routes/_app.chatbot'
import { Route as AppActivityRouteImport } from './routes/_app.activity'
import { Route as AppUsersIndexRouteImport } from './routes/_app.users.index'
import { Route as AppPostTypesIndexRouteImport } from './routes/_app.post-types.index'
import { Route as AppPagesIndexRouteImport } from './routes/_app.pages.index'
import { Route as AppMediaIndexRouteImport } from './routes/_app.media.index'
import { Route as AppFormsIndexRouteImport } from './routes/_app.forms.index'
import { Route as AppPagesIdRouteImport } from './routes/_app.pages.$id'
import { Route as AppFormsNewRouteImport } from './routes/_app.forms.new'
import { Route as AppFormsIdRouteImport } from './routes/_app.forms.$id'
import { Route as AppAiLeadsRouteImport } from './routes/_app.ai.leads'
import { Route as AppAiConversationsIndexRouteImport } from './routes/_app.ai.conversations.index'
import { Route as AppAiConversationsIdRouteImport } from './routes/_app.ai.conversations.$id'
import { Route as AppPostTypesKeyPostsIndexRouteImport } from './routes/_app.post-types.$key.posts.index'
import { Route as AppPostTypesKeyPostsIdRouteImport } from './routes/_app.post-types.$key.posts.$id'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppThemeRoute = AppThemeRouteImport.update({
  id: '/theme',
  path: '/theme',
  getParentRoute: () => AppRoute,
} as any)
const AppTaxonomiesRoute = AppTaxonomiesRouteImport.update({
  id: '/taxonomies',
  path: '/taxonomies',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppRedirectsRoute = AppRedirectsRouteImport.update({
  id: '/redirects',
  path: '/redirects',
  getParentRoute: () => AppRoute,
} as any)
const AppProfileRoute = AppProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppRoute,
} as any)
const AppPatternsRoute = AppPatternsRouteImport.update({
  id: '/patterns',
  path: '/patterns',
  getParentRoute: () => AppRoute,
} as any)
const AppPageTemplatesRoute = AppPageTemplatesRouteImport.update({
  id: '/page-templates',
  path: '/page-templates',
  getParentRoute: () => AppRoute,
} as any)
const AppNewsletterRoute = AppNewsletterRouteImport.update({
  id: '/newsletter',
  path: '/newsletter',
  getParentRoute: () => AppRoute,
} as any)
const AppMessagesRoute = AppMessagesRouteImport.update({
  id: '/messages',
  path: '/messages',
  getParentRoute: () => AppRoute,
} as any)
const AppIntegrationsRoute = AppIntegrationsRouteImport.update({
  id: '/integrations',
  path: '/integrations',
  getParentRoute: () => AppRoute,
} as any)
const AppChatbotRoute = AppChatbotRouteImport.update({
  id: '/chatbot',
  path: '/chatbot',
  getParentRoute: () => AppRoute,
} as any)
const AppActivityRoute = AppActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => AppRoute,
} as any)
const AppUsersIndexRoute = AppUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AppRoute,
} as any)
const AppPostTypesIndexRoute = AppPostTypesIndexRouteImport.update({
  id: '/post-types/',
  path: '/post-types/',
  getParentRoute: () => AppRoute,
} as any)
const AppPagesIndexRoute = AppPagesIndexRouteImport.update({
  id: '/pages/',
  path: '/pages/',
  getParentRoute: () => AppRoute,
} as any)
const AppMediaIndexRoute = AppMediaIndexRouteImport.update({
  id: '/media/',
  path: '/media/',
  getParentRoute: () => AppRoute,
} as any)
const AppFormsIndexRoute = AppFormsIndexRouteImport.update({
  id: '/forms/',
  path: '/forms/',
  getParentRoute: () => AppRoute,
} as any)
const AppPagesIdRoute = AppPagesIdRouteImport.update({
  id: '/pages/$id',
  path: '/pages/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppFormsNewRoute = AppFormsNewRouteImport.update({
  id: '/forms/new',
  path: '/forms/new',
  getParentRoute: () => AppRoute,
} as any)
const AppFormsIdRoute = AppFormsIdRouteImport.update({
  id: '/forms/$id',
  path: '/forms/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppAiLeadsRoute = AppAiLeadsRouteImport.update({
  id: '/ai/leads',
  path: '/ai/leads',
  getParentRoute: () => AppRoute,
} as any)
const AppAiConversationsIndexRoute = AppAiConversationsIndexRouteImport.update({
  id: '/ai/conversations/',
  path: '/ai/conversations/',
  getParentRoute: () => AppRoute,
} as any)
const AppAiConversationsIdRoute = AppAiConversationsIdRouteImport.update({
  id: '/ai/conversations/$id',
  path: '/ai/conversations/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppPostTypesKeyPostsIndexRoute =
  AppPostTypesKeyPostsIndexRouteImport.update({
    id: '/post-types/$key/posts/',
    path: '/post-types/$key/posts/',
    getParentRoute: () => AppRoute,
  } as any)
const AppPostTypesKeyPostsIdRoute = AppPostTypesKeyPostsIdRouteImport.update({
  id: '/post-types/$key/posts/$id',
  path: '/post-types/$key/posts/$id',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/login': typeof LoginRoute
  '/activity': typeof AppActivityRoute
  '/chatbot': typeof AppChatbotRoute
  '/integrations': typeof AppIntegrationsRoute
  '/messages': typeof AppMessagesRoute
  '/newsletter': typeof AppNewsletterRoute
  '/page-templates': typeof AppPageTemplatesRoute
  '/patterns': typeof AppPatternsRoute
  '/profile': typeof AppProfileRoute
  '/redirects': typeof AppRedirectsRoute
  '/settings': typeof AppSettingsRoute
  '/taxonomies': typeof AppTaxonomiesRoute
  '/theme': typeof AppThemeRoute
  '/ai/leads': typeof AppAiLeadsRoute
  '/forms/$id': typeof AppFormsIdRoute
  '/forms/new': typeof AppFormsNewRoute
  '/pages/$id': typeof AppPagesIdRoute
  '/forms/': typeof AppFormsIndexRoute
  '/media/': typeof AppMediaIndexRoute
  '/pages/': typeof AppPagesIndexRoute
  '/post-types/': typeof AppPostTypesIndexRoute
  '/users/': typeof AppUsersIndexRoute
  '/ai/conversations/$id': typeof AppAiConversationsIdRoute
  '/ai/conversations/': typeof AppAiConversationsIndexRoute
  '/post-types/$key/posts/$id': typeof AppPostTypesKeyPostsIdRoute
  '/post-types/$key/posts/': typeof AppPostTypesKeyPostsIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/activity': typeof AppActivityRoute
  '/chatbot': typeof AppChatbotRoute
  '/integrations': typeof AppIntegrationsRoute
  '/messages': typeof AppMessagesRoute
  '/newsletter': typeof AppNewsletterRoute
  '/page-templates': typeof AppPageTemplatesRoute
  '/patterns': typeof AppPatternsRoute
  '/profile': typeof AppProfileRoute
  '/redirects': typeof AppRedirectsRoute
  '/settings': typeof AppSettingsRoute
  '/taxonomies': typeof AppTaxonomiesRoute
  '/theme': typeof AppThemeRoute
  '/': typeof AppIndexRoute
  '/ai/leads': typeof AppAiLeadsRoute
  '/forms/$id': typeof AppFormsIdRoute
  '/forms/new': typeof AppFormsNewRoute
  '/pages/$id': typeof AppPagesIdRoute
  '/forms': typeof AppFormsIndexRoute
  '/media': typeof AppMediaIndexRoute
  '/pages': typeof AppPagesIndexRoute
  '/post-types': typeof AppPostTypesIndexRoute
  '/users': typeof AppUsersIndexRoute
  '/ai/conversations/$id': typeof AppAiConversationsIdRoute
  '/ai/conversations': typeof AppAiConversationsIndexRoute
  '/post-types/$key/posts/$id': typeof AppPostTypesKeyPostsIdRoute
  '/post-types/$key/posts': typeof AppPostTypesKeyPostsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/_app/activity': typeof AppActivityRoute
  '/_app/chatbot': typeof AppChatbotRoute
  '/_app/integrations': typeof AppIntegrationsRoute
  '/_app/messages': typeof AppMessagesRoute
  '/_app/newsletter': typeof AppNewsletterRoute
  '/_app/page-templates': typeof AppPageTemplatesRoute
  '/_app/patterns': typeof AppPatternsRoute
  '/_app/profile': typeof AppProfileRoute
  '/_app/redirects': typeof AppRedirectsRoute
  '/_app/settings': typeof AppSettingsRoute
  '/_app/taxonomies': typeof AppTaxonomiesRoute
  '/_app/theme': typeof AppThemeRoute
  '/_app/': typeof AppIndexRoute
  '/_app/ai/leads': typeof AppAiLeadsRoute
  '/_app/forms/$id': typeof AppFormsIdRoute
  '/_app/forms/new': typeof AppFormsNewRoute
  '/_app/pages/$id': typeof AppPagesIdRoute
  '/_app/forms/': typeof AppFormsIndexRoute
  '/_app/media/': typeof AppMediaIndexRoute
  '/_app/pages/': typeof AppPagesIndexRoute
  '/_app/post-types/': typeof AppPostTypesIndexRoute
  '/_app/users/': typeof AppUsersIndexRoute
  '/_app/ai/conversations/$id': typeof AppAiConversationsIdRoute
  '/_app/ai/conversations/': typeof AppAiConversationsIndexRoute
  '/_app/post-types/$key/posts/$id': typeof AppPostTypesKeyPostsIdRoute
  '/_app/post-types/$key/posts/': typeof AppPostTypesKeyPostsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/activity'
    | '/chatbot'
    | '/integrations'
    | '/messages'
    | '/newsletter'
    | '/page-templates'
    | '/patterns'
    | '/profile'
    | '/redirects'
    | '/settings'
    | '/taxonomies'
    | '/theme'
    | '/ai/leads'
    | '/forms/$id'
    | '/forms/new'
    | '/pages/$id'
    | '/forms/'
    | '/media/'
    | '/pages/'
    | '/post-types/'
    | '/users/'
    | '/ai/conversations/$id'
    | '/ai/conversations/'
    | '/post-types/$key/posts/$id'
    | '/post-types/$key/posts/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/activity'
    | '/chatbot'
    | '/integrations'
    | '/messages'
    | '/newsletter'
    | '/page-templates'
    | '/patterns'
    | '/profile'
    | '/redirects'
    | '/settings'
    | '/taxonomies'
    | '/theme'
    | '/'
    | '/ai/leads'
    | '/forms/$id'
    | '/forms/new'
    | '/pages/$id'
    | '/forms'
    | '/media'
    | '/pages'
    | '/post-types'
    | '/users'
    | '/ai/conversations/$id'
    | '/ai/conversations'
    | '/post-types/$key/posts/$id'
    | '/post-types/$key/posts'
  id:
    | '__root__'
    | '/_app'
    | '/login'
    | '/_app/activity'
    | '/_app/chatbot'
    | '/_app/integrations'
    | '/_app/messages'
    | '/_app/newsletter'
    | '/_app/page-templates'
    | '/_app/patterns'
    | '/_app/profile'
    | '/_app/redirects'
    | '/_app/settings'
    | '/_app/taxonomies'
    | '/_app/theme'
    | '/_app/'
    | '/_app/ai/leads'
    | '/_app/forms/$id'
    | '/_app/forms/new'
    | '/_app/pages/$id'
    | '/_app/forms/'
    | '/_app/media/'
    | '/_app/pages/'
    | '/_app/post-types/'
    | '/_app/users/'
    | '/_app/ai/conversations/$id'
    | '/_app/ai/conversations/'
    | '/_app/post-types/$key/posts/$id'
    | '/_app/post-types/$key/posts/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/theme': {
      id: '/_app/theme'
      path: '/theme'
      fullPath: '/theme'
      preLoaderRoute: typeof AppThemeRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/taxonomies': {
      id: '/_app/taxonomies'
      path: '/taxonomies'
      fullPath: '/taxonomies'
      preLoaderRoute: typeof AppTaxonomiesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/redirects': {
      id: '/_app/redirects'
      path: '/redirects'
      fullPath: '/redirects'
      preLoaderRoute: typeof AppRedirectsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/profile': {
      id: '/_app/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AppProfileRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/patterns': {
      id: '/_app/patterns'
      path: '/patterns'
      fullPath: '/patterns'
      preLoaderRoute: typeof AppPatternsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/page-templates': {
      id: '/_app/page-templates'
      path: '/page-templates'
      fullPath: '/page-templates'
      preLoaderRoute: typeof AppPageTemplatesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/newsletter': {
      id: '/_app/newsletter'
      path: '/newsletter'
      fullPath: '/newsletter'
      preLoaderRoute: typeof AppNewsletterRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/messages': {
      id: '/_app/messages'
      path: '/messages'
      fullPath: '/messages'
      preLoaderRoute: typeof AppMessagesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/integrations': {
      id: '/_app/integrations'
      path: '/integrations'
      fullPath: '/integrations'
      preLoaderRoute: typeof AppIntegrationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/chatbot': {
      id: '/_app/chatbot'
      path: '/chatbot'
      fullPath: '/chatbot'
      preLoaderRoute: typeof AppChatbotRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/activity': {
      id: '/_app/activity'
      path: '/activity'
      fullPath: '/activity'
      preLoaderRoute: typeof AppActivityRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/users/': {
      id: '/_app/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AppUsersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/post-types/': {
      id: '/_app/post-types/'
      path: '/post-types'
      fullPath: '/post-types/'
      preLoaderRoute: typeof AppPostTypesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pages/': {
      id: '/_app/pages/'
      path: '/pages'
      fullPath: '/pages/'
      preLoaderRoute: typeof AppPagesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/media/': {
      id: '/_app/media/'
      path: '/media'
      fullPath: '/media/'
      preLoaderRoute: typeof AppMediaIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/forms/': {
      id: '/_app/forms/'
      path: '/forms'
      fullPath: '/forms/'
      preLoaderRoute: typeof AppFormsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pages/$id': {
      id: '/_app/pages/$id'
      path: '/pages/$id'
      fullPath: '/pages/$id'
      preLoaderRoute: typeof AppPagesIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/forms/new': {
      id: '/_app/forms/new'
      path: '/forms/new'
      fullPath: '/forms/new'
      preLoaderRoute: typeof AppFormsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/forms/$id': {
      id: '/_app/forms/$id'
      path: '/forms/$id'
      fullPath: '/forms/$id'
      preLoaderRoute: typeof AppFormsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ai/leads': {
      id: '/_app/ai/leads'
      path: '/ai/leads'
      fullPath: '/ai/leads'
      preLoaderRoute: typeof AppAiLeadsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ai/conversations/': {
      id: '/_app/ai/conversations/'
      path: '/ai/conversations'
      fullPath: '/ai/conversations/'
      preLoaderRoute: typeof AppAiConversationsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ai/conversations/$id': {
      id: '/_app/ai/conversations/$id'
      path: '/ai/conversations/$id'
      fullPath: '/ai/conversations/$id'
      preLoaderRoute: typeof AppAiConversationsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/post-types/$key/posts/': {
      id: '/_app/post-types/$key/posts/'
      path: '/post-types/$key/posts'
      fullPath: '/post-types/$key/posts/'
      preLoaderRoute: typeof AppPostTypesKeyPostsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/post-types/$key/posts/$id': {
      id: '/_app/post-types/$key/posts/$id'
      path: '/post-types/$key/posts/$id'
      fullPath: '/post-types/$key/posts/$id'
      preLoaderRoute: typeof AppPostTypesKeyPostsIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppActivityRoute: typeof AppActivityRoute
  AppChatbotRoute: typeof AppChatbotRoute
  AppIntegrationsRoute: typeof AppIntegrationsRoute
  AppMessagesRoute: typeof AppMessagesRoute
  AppNewsletterRoute: typeof AppNewsletterRoute
  AppPageTemplatesRoute: typeof AppPageTemplatesRoute
  AppPatternsRoute: typeof AppPatternsRoute
  AppProfileRoute: typeof AppProfileRoute
  AppRedirectsRoute: typeof AppRedirectsRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppTaxonomiesRoute: typeof AppTaxonomiesRoute
  AppThemeRoute: typeof AppThemeRoute
  AppIndexRoute: typeof AppIndexRoute
  AppAiLeadsRoute: typeof AppAiLeadsRoute
  AppFormsIdRoute: typeof AppFormsIdRoute
  AppFormsNewRoute: typeof AppFormsNewRoute
  AppPagesIdRoute: typeof AppPagesIdRoute
  AppFormsIndexRoute: typeof AppFormsIndexRoute
  AppMediaIndexRoute: typeof AppMediaIndexRoute
  AppPagesIndexRoute: typeof AppPagesIndexRoute
  AppPostTypesIndexRoute: typeof AppPostTypesIndexRoute
  AppUsersIndexRoute: typeof AppUsersIndexRoute
  AppAiConversationsIdRoute: typeof AppAiConversationsIdRoute
  AppAiConversationsIndexRoute: typeof AppAiConversationsIndexRoute
  AppPostTypesKeyPostsIdRoute: typeof AppPostTypesKeyPostsIdRoute
  AppPostTypesKeyPostsIndexRoute: typeof AppPostTypesKeyPostsIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppActivityRoute: AppActivityRoute,
  AppChatbotRoute: AppChatbotRoute,
  AppIntegrationsRoute: AppIntegrationsRoute,
  AppMessagesRoute: AppMessagesRoute,
  AppNewsletterRoute: AppNewsletterRoute,
  AppPageTemplatesRoute: AppPageTemplatesRoute,
  AppPatternsRoute: AppPatternsRoute,
  AppProfileRoute: AppProfileRoute,
  AppRedirectsRoute: AppRedirectsRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppTaxonomiesRoute: AppTaxonomiesRoute,
  AppThemeRoute: AppThemeRoute,
  AppIndexRoute: AppIndexRoute,
  AppAiLeadsRoute: AppAiLeadsRoute,
  AppFormsIdRoute: AppFormsIdRoute,
  AppFormsNewRoute: AppFormsNewRoute,
  AppPagesIdRoute: AppPagesIdRoute,
  AppFormsIndexRoute: AppFormsIndexRoute,
  AppMediaIndexRoute: AppMediaIndexRoute,
  AppPagesIndexRoute: AppPagesIndexRoute,
  AppPostTypesIndexRoute: AppPostTypesIndexRoute,
  AppUsersIndexRoute: AppUsersIndexRoute,
  AppAiConversationsIdRoute: AppAiConversationsIdRoute,
  AppAiConversationsIndexRoute: AppAiConversationsIndexRoute,
  AppPostTypesKeyPostsIdRoute: AppPostTypesKeyPostsIdRoute,
  AppPostTypesKeyPostsIndexRoute: AppPostTypesKeyPostsIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
